import React from "react";
import Link from "helpers/link";
import { getButtonStyle } from "helpers/get-button-style";
import Image from "components/image";

const Button = ({ button: { text, style, url, iconShown, icon }, className }) => {
  return (
    <Link to={url} className={`btn ${getButtonStyle(style)} ${className}`}>
      {text}

      {iconShown && (
        <Image image={icon?.asset} alt={icon?.alt} className="w-6 h-6" />
      )}
    </Link>
  );
};

export default Button;
